const isUX1Country = locale => {
  const UX1Countries = ['in', 'us', 'mx', 'jp']
  return UX1Countries.indexOf(locale) > -1
}

export default isUX1Country
